<!-- CONDIÇÕES DE SAÚDE -->
<mat-toolbar class="titulopartes">Condição de Saúde</mat-toolbar>

<!--
<div fxLayout="row" fxLayoutGap="20px" fxFlexFill>
    <mat-form-field fxFlex="15%" fxFlexOffset="20px">
        <mat-label>Possui deficiência:</mat-label>
        <mat-select [(ngModel)]="pessoaFisica.ehDeficiente" name="ehDeficiente">
            <mat-option *ngFor="let m of sim_nao" [value]="m.flag">
                {{m.tipo}}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>
-->

<div fxLayout="row" fxLayoutGap="20px" fxFlexFill>
    <mat-form-field fxFlexOffset="20px" style="margin: 0 0 0 20px" fxFlex="45%" appearance="outline">
        <mat-label>Descrição da deficiência:</mat-label>
        <textarea #descricaoDeficiencia matInput name="descricaoDeficiencia"
            [(ngModel)]="pessoaFisica.descricaoDeficiencia" cdkTextareaAutosize #autosize="cdkTextareaAutosize"
            cdkAutosizeMinRows="3" maxlength="200"></textarea>
        <mat-hint align="end">{{descricaoDeficiencia.value.length}} / 200</mat-hint>
    </mat-form-field>

    <mat-form-field fxFlexOffset="20px" fxFlex="50%" appearance="outline">
        <mat-label>Descrição de problemas de saúde:</mat-label>
        <textarea matInput #problemaSaude name="problemaSaude" [(ngModel)]="pessoaFisica.problemaSaude"
            cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3" maxlength="200"></textarea>
        <mat-hint align="end">{{problemaSaude.value.length}} / 200</mat-hint>
    </mat-form-field>

    <mat-form-field fxFlexOffset="20px" fxFlex="50%" appearance="outline">
        <mat-label>Descrição dos medicamentos controlados utilizados:</mat-label>
        <textarea matInput #medicamentosControlados name="medicamentosControlados"
            [(ngModel)]="pessoaFisica.medicamentosControlados" cdkTextareaAutosize #autosize="cdkTextareaAutosize"
            cdkAutosizeMinRows="3" maxlength="200"></textarea>
        <mat-hint align="end">{{medicamentosControlados.value.length}} / 200</mat-hint>
    </mat-form-field>



</div>

<!-- MORADIA -->
<mat-toolbar class="titulopartes">Moradia</mat-toolbar>
<div fxLayout="row" fxLayoutGap="50px" fxFlexFill>

    <mat-form-field fxFlex="50%" fxFlexOffset="20px">
        <mat-label>Condição da Moradia:</mat-label>
        <mat-select [(ngModel)]="pessoaFisica.condicoesMoradia.id" name="condicoesMoradia">
            <mat-option *ngFor="let m of condicoesMoradia" [value]="m.id">
                {{m.descricao}}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field fxFlex="50%">
        <input matInput maxlength="200" name="condicaoMoradia" placeholder="Descrição da condição moradia:"
            [(ngModel)]="pessoaFisica.condicaoMoradia">
    </mat-form-field>

</div>


<!-- OUTRAS INFORMAÇÕES -->
<mat-toolbar class="titulopartes">Apoio</mat-toolbar>
<div *ngIf="origemTelaAluno" fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
    <mat-form-field fxFlex="50%" fxFlexOffset="20px">
            <mat-label>Já atendido em outro órgão da rede</mat-label>
            <mat-select [(ngModel)]="atendidoOrgaoRede" name="atendidoOrgaoRede">
                <mat-option *ngFor="let m of sim_nao" [value]="m.flag">
                    {{m.tipo}}
                </mat-option>
            </mat-select>
    </mat-form-field>
</div>

<div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>    
    <mat-form-field fxFlexOffset="20px" fxFlex="50%" appearance="outline">
        <mat-label>Descrição relevante do atendimento por outro órgão da rede:</mat-label>
        <textarea matInput #descricaoPessoaFisicaAtendidoOrgaoRede name="descricaoPessoaFisicaAtendidoOrgaoRede"
            [(ngModel)]="pessoaFisica.descricaoPessoaFisicaAtendidoOrgaoRede" cdkTextareaAutosize
            #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="2" maxlength="200"></textarea>
        <mat-hint align="end">{{descricaoPessoaFisicaAtendidoOrgaoRede.value.length}} / 200</mat-hint>
    </mat-form-field>

    <mat-form-field fxFlexOffset="20px" fxFlex="50%" appearance="outline">
        <mat-label>Descrição da rede de apoio social / pessoal:</mat-label>
        <textarea matInput #redeApSocRelev name="redeApSocRelev" [(ngModel)]="pessoaFisica.redeApSocRelev"
            cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="2" maxlength="200"></textarea>
        <mat-hint align="end">{{redeApSocRelev.value.length}} / 200</mat-hint>
    </mat-form-field>

</div>

<div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
    <mat-form-field fxFlexOffset="20px" fxFlex="100%" appearance="outline">
        <mat-label>Descrição relevante da rede de apoio social / pessoal:</mat-label>
        <textarea matInput #redeApoioSocial name="redeApoioSocial" [(ngModel)]="pessoaFisica.redeApoioSocial"
            cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="2" maxlength="200"></textarea>
        <mat-hint align="end">{{redeApoioSocial.value.length}} / 200</mat-hint>
    </mat-form-field>
   
</div>

<!-- BENEFICIOS -->
<mat-toolbar class="titulopartes">Benefícios</mat-toolbar>
<div fxLayout="column" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
    
    <div fxFlex="100%" fxLayoutGap="20px" fxFlexOffset="20px" ngModelGroup="grupoBeneficio">
        <div *ngFor="let beneficio of beneficiosSociaisPessoaFisica; let index = index">
            <beneficio-social-pessoa-fisica 
                                       [beneficio]="beneficio" 
                                       [index]="index"
                                       [beneficiosSociaisPessoaFisica]="beneficiosSociaisPessoaFisica"   
                                       [perfilAcesso]="perfilAcesso"
                                       [beneficiosSociais]="beneficiosSociais" 
                                       >
            </beneficio-social-pessoa-fisica>
        </div>
        <div *ngIf="perfilAcesso.insere" fxLayoutAlign="start center" fxLayoutGap="16px" style="padding-top: 10px; padding-left: 20px; padding-bottom: 10px;">
            <div>
                <button matTooltip="Novo" mat-mini-fab color="primary" (click)="addBeneficio()">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>                
    </div>

</div>

<div style="width: 100%;" *ngIf="origemTelaAluno">
    <mat-toolbar class="titulopartes">Origem do Beneficiário</mat-toolbar>
    <div fxLayout="column" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
    
        <div fxFlex="100%" fxLayoutGap="20px" fxFlexOffset="20px" ngModelGroup="grupoEncaminhamento">
            <div *ngFor="let encaminhamento of encaminhamentos; let index = index">
                <formulario-encaminhamento [encaminhamento]="encaminhamento" 
                                           [index]="index"
                                           [encaminhamentos]="encaminhamentos"   
                                           [perfilAcesso]="perfilAcesso" 
                                           [entidadesSociais]="entidadesSociais">
                </formulario-encaminhamento>
            </div>
            <div *ngIf="perfilAcesso.insere" fxLayoutAlign="start center" fxLayoutGap="16px" style="padding-top: 10px; padding-left: 20px;">
                <div>
                    <button matTooltip="Novo" mat-mini-fab color="primary" (click)="addEncaminhamento()">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>                
        </div>
    
    </div>
</div>